module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt02"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "ph02"
    }
  }, [_c('h2', {
    staticClass: "partNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("II")])]), _vm._v(" "), _c('div', {
    staticClass: "partEpigraph"
  }, [_c('p', {
    staticClass: "partEpigraphText"
  }, [_vm._v("And he is the guardian of the world, he is the king of the world, he is lord of the universe—and he is myself, thus let it be known, yea, thus let it be known!")]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphSource"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kaushitaki-Upanishad,"), _c('br'), _vm._v(" III Adhyava, 8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "partBody"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f887b06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/futureindefinite_pt02.vue
// module id = 96
// module chunks = 0